var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsAppIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_52_63097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 74L14.9449 56.0261C11.89 50.7533 10.2854 44.772 10.2927 38.685C10.3008 19.5594 25.9348 4 45.1466 4C54.4695 4.00472 63.2201 7.61658 69.8012 14.173C76.3823 20.7294 80.0033 29.4443 80 38.7128C79.9915 57.8369 64.3551 73.3992 45.1461 73.3992H45.131C39.2983 73.3968 33.567 71.9401 28.4762 69.1766L10 74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1568 9.85994C29.1775 9.85994 16.1825 22.7922 16.1768 38.6879C16.1689 44.1158 17.7043 49.4351 20.6054 54.0308L21.2946 55.1216L18.3676 65.7596L29.3319 62.8975L30.3906 63.5219C34.8372 66.1491 39.9357 67.5384 45.135 67.5412H45.1459C61.1129 67.5412 74.1079 54.6076 74.114 38.711C74.1261 34.9221 73.3831 31.1684 71.928 27.6673C70.473 24.1663 68.3347 20.9873 65.6372 18.3145C62.9546 15.6271 59.7632 13.4961 56.2477 12.0448C52.7322 10.5936 48.9625 9.85098 45.1568 9.85994Z",
    fill: "url(#paint0_linear_52_63097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4359 24.1845C35.7831 22.741 35.0962 22.7118 34.4762 22.6868L32.8069 22.6665C32.2261 22.6665 31.2825 22.8834 30.4848 23.7511C29.6871 24.6189 27.4365 26.716 27.4365 30.9815C27.4365 35.2469 30.5573 39.3686 30.9921 39.9477C31.427 40.5268 37.0166 49.559 45.8686 53.0341C53.2247 55.9221 54.7216 55.3477 56.3189 55.2034C57.9162 55.0591 61.4714 53.1063 62.1966 51.0818C62.9218 49.0573 62.9223 47.3228 62.7049 46.9601C62.4874 46.5975 61.9067 46.382 61.0351 45.9481C60.1635 45.5143 55.8827 43.4171 55.0845 43.1276C54.2863 42.838 53.706 42.6942 53.1248 43.5619C52.5435 44.4296 50.8766 46.3815 50.3683 46.9601C49.86 47.5388 49.3527 47.6114 48.4811 47.178C47.6095 46.7446 44.8052 45.8288 41.4779 42.8753C38.8892 40.5773 37.1417 37.7393 36.6329 36.872C36.1242 36.0048 36.5789 35.5351 37.0157 35.1031C37.4065 34.7145 37.8863 34.0906 38.3226 33.5846C38.7589 33.0786 38.9024 32.7169 39.1923 32.1392C39.4822 31.5615 39.3378 31.0541 39.1199 30.6207C38.9019 30.1873 37.2099 25.8997 36.4359 24.185",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_52_63097",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52_63097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_52_63097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_63097",
    x1: 44.5556,
    y1: 13.3214,
    x2: 44.8467,
    y2: 62.6137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppIc);
export default __webpack_public_path__ + "static/media/whatsApp_ic.89eda183.svg";
export { ForwardRef as ReactComponent };